import React from "react";
import { FiArrowRight, FiBarChart2 } from "react-icons/fi";
import "./Trial.css";
import service1 from "../Images/services/service-1.png";
import icon1 from "../Images/services/icon-1.png";
import service2 from "../Images/services/service-2.png";
import icon2 from "../Images/services/icon-2.png";
import service3 from "../Images/services/service-3.png";
import icon3 from "../Images/services/icon-3.png";
import service4 from "../Images/services/service-4.png";
import icon4 from "../Images/services/icon-4.png";
import service5 from "../Images/services/service-5.png";
import icon5 from "../Images/services/icon-5.png";
import service6 from "../Images/services/service-6.png";
import icon6 from "../Images/services/icon-6.png";
import rocket from "../Images/services/rocket.png";
const serviceImages = [service1, service2, service3, service4, service5, service6];
const serviceIcons = [icon1, icon2, icon3, icon4, icon5, icon6];

const Trialcards = () => {
  const cardsData = [
    {
      title: "Integrated Search Console, Google Trends and Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website metrics. Seobix makes it easy and effective.",
    },
    {
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <section className="trial-services" aria-labelledby="trial-services-title">
      <div className="trial-services-inner home-content">
        <header className="trial-services-heading">
          <span className="trial-services-eyebrow"><FiBarChart2 aria-hidden="true" /> ALL-IN-ONE SEO SOLUTIONS</span>
          <h2 id="trial-services-title">Comprehensive <span>SEO Services</span></h2>
          <p>Optimize your online presence with SeoBix. Boost visibility, drive traffic, and improve rankings to achieve your business goals and long-term growth.</p>
        </header>
        <div className="trial-services-grid">
          {cardsData.map(({ title, desc }, index) => (
            <article className={`trial-service-card trial-service-tone-${index}`} key={title}>
              <div className="trial-service-topline">
                <span className="trial-service-icon"><img src={serviceIcons[index]} alt="" width="67" height="62" /></span>
                <span className="trial-service-number">{String(index + 1).padStart(2, "0")}</span>
              </div>
              <div className="trial-service-body">
                <div className="trial-service-copy"><h3>{title}</h3><p>{desc}</p></div>
                <div className="trial-service-art"><img src={serviceImages[index]} alt="" decoding="async" loading="lazy" /></div>
              </div>
              <a className="trial-service-link" href="https://dashboard.seobix.com/" target="_blank" rel="noopener noreferrer" aria-label={`Check ${title} for free`}>Check for free <FiArrowRight aria-hidden="true" /></a>
            </article>
          ))}
        </div>
        <div className="trial-services-cta">
          <span className="trial-services-rocket"><img src={rocket} alt="" width="70" height="70" /></span>
          <div><h3>Ready to grow your online presence?</h3><p>Join thousands of businesses using SeoBix to rank higher and get results.</p></div>
          <a href="https://dashboard.seobix.com/" target="_blank" rel="noopener noreferrer">Get Started Now <FiArrowRight aria-hidden="true" /></a>
        </div>
      </div>
    </section>
  );
};

export default Trialcards;
